import React from 'react';
import { FormattedMessage } from '../../../util/reactIntl';
import { Form as FinalForm } from 'react-final-form';
import * as validators from '../../../util/validators';
import classNames from 'classnames';
import { Button, FieldTextInput, Form } from '../../../components';
import css from './SectionNotifyMe.module.css';

const SectionNotifyMe = props => {
  const { currentState, currentSubject, notifyMeSuccess, notifyMeError, content, intl } = props;

  return (
    <div className={css.root} id='contact' name='contact'>
      <div className={css.titleHolder}>
        <div className={css.title}>
          {content?.getNotifiedTitle ? content.getNotifiedTitle :
            currentState && !currentSubject ?
              <FormattedMessage id="SectionNotifyMe.stateTitle"  values={{ state: currentState?.label }} /> :
            currentState && currentSubject ?
              <FormattedMessage id="SectionNotifyMe.stateAndSubjectTitle"  values={{ state: currentState?.label, subject: currentSubject?.parent }} /> :
            <FormattedMessage id="SectionNotifyMe.title"   />
          }
        </div>

        <div className={css.description}>
          {content?.getNotifiedDescription ? content.getNotifiedDescription :
            currentState && !currentSubject ?
              <FormattedMessage id='SectionNotifyMe.stateDescription' values={{state: currentState?.label}} /> :
              currentState && currentSubject ?
              <FormattedMessage id='SectionNotifyMe.subjectDescription' values={{state: currentState?.label, subject: currentSubject?.parent}} /> :
              <FormattedMessage id='SectionNotifyMe.description' />
          }
        </div>
      </div>

      <div className={css.formHolder}>
        <FinalForm
          {...props}
          render={fieldRenderProps => {
            const {
              rootClassName,
              formId,
              handleSubmit,
              inProgress,
              intl,
              invalid,
            } = fieldRenderProps;

            const firstNamePlaceholder = intl.formatMessage({ id: 'ContactForm.firstNamePlaceholder' });
            const lastNamePlaceholder = intl.formatMessage({ id: 'ContactForm.lastNamePlaceholder' });
            const emailPlaceholder = intl.formatMessage({ id: 'ContactForm.emailAddressPlaceholder' });
            const emailRequiredMessage = intl.formatMessage({ id: 'ContactForm.emailRequired' });
            const emailRequired = validators.required(emailRequiredMessage);
            const emailInvalidMessage = intl.formatMessage({ id: 'ContactForm.emailInvalid' });
            const emailValid = validators.emailFormatValid(emailInvalidMessage);
            const messageRequiredMessage = intl.formatMessage({ id: 'ContactForm.messageRequired', });
            const messageRequired = validators.required(messageRequiredMessage);


            const classes = classNames(rootClassName || css.form);
            const submitInProgress = inProgress;
            const submitDisabled = invalid || submitInProgress;

            return (
              <Form className={classes} onSubmit={handleSubmit}>
                <div className={css.contactUsInputShortHolder}>
                  <FieldTextInput
                    className={classNames(css.contactUsInput, css.contactUsInputShort)}
                    type='text'
                    id={formId ? `${formId}.firstName` : 'firstName'}
                    name='firstName'
                    autoComplete='firstName'
                    placeholder={firstNamePlaceholder}
                    validate={messageRequired}
                  />

                  <FieldTextInput
                    className={classNames(css.contactUsInput, css.contactUsInputShort)}
                    type='text'
                    id={formId ? `${formId}.lastName` : 'lastName'}
                    name='lastName'
                    autoComplete='lastName'
                    placeholder={lastNamePlaceholder}
                    validate={messageRequired}
                  />
                </div>
                <FieldTextInput
                  className={css.contactUsInput}
                  type='email'
                  id={formId ? `${formId}.email` : 'email'}
                  name='email'
                  autoComplete='email'
                  placeholder={emailPlaceholder}
                  validate={validators.composeValidators(emailRequired, emailValid)}
                />

                <div className={css.contactUsButtonHolder}>
                  <Button type='submit' inProgress={submitInProgress} disabled={submitDisabled}
                          className={css.contactUsButton}>
                    {content?.getNotifiedButton ? content.getNotifiedButton :
                      <FormattedMessage id='ContactForm.btnNotify' />}
                  </Button>
                </div>
                {notifyMeSuccess && (
                  <p className={css.successMsg}>
                    <FormattedMessage id='ContactForm.successMsg' values={{ lineBreak: <br /> }} />
                  </p>
                )}
                {!!notifyMeError && (
                  <p className={css.error}>
                    <FormattedMessage id='EnquiryForm.sendEnquiryError' />
                  </p>
                )}

              </Form>
            );
          }}
        />
      </div>
    </div>
  );
};

export default SectionNotifyMe;
